import {ActivityIndicator} from "antd-mobile";
import React from "react";

interface Props {
  loading?: boolean,
  full?: boolean,
  height?: string,
  size?: 'small' | 'large'
}

const LoadingPanel: React.FC<Props> = ({
  loading,
  full = false,
  height = '100%',
  size= 'small',

}) => {
  let styles: object = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px'
  }
  if (full) {
    styles = {
      ...styles,
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }
  else {
    styles = {
      ...styles,
      height,
    }
  }

  if (!loading) {
    return null
  }

  return <div style={styles}><ActivityIndicator size={size}/></div>
}
export default LoadingPanel